import React from 'react';
import { AgendaItem, AgendaType } from '@/types';

export const TONE_DOT: Record<AgendaType, string> = {
  edital:   'bg-brand-500',
  certidao: 'bg-warning dark:bg-warning-dark',
  contrato: 'bg-success dark:bg-success-dark',
  sessao:   'bg-info dark:bg-info-dark',
  tarefa:   'bg-violet-500 dark:bg-violet-400',
};

export const TYPE_LABEL: Record<AgendaType, string> = {
  edital:   'Editais',
  certidao: 'Certidões',
  contrato: 'Contratos',
  sessao:   'Sessões',
  tarefa:   'Tarefas',
};

interface EventPillProps {
  event: AgendaItem;
  delay?: number;
  inverted?: boolean;
}

export const EventPill: React.FC<EventPillProps> = ({ event, delay = 0, inverted = false }) => {
  const label = event.title.split('—')[0].trim();
  return (
    <div
      className="flex items-center gap-1.5 py-0.5 pr-0.5 mb-0.5 text-[11px] leading-[1.3] animate-fade-in whitespace-nowrap overflow-hidden"
      style={{ animationDelay: `${delay}ms` }}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${TONE_DOT[event.type]}`} />
      <span
        className={[
          'flex-1 min-w-0 overflow-hidden text-ellipsis font-normal',
          inverted ? 'text-white/90' : 'text-ink-label dark:text-ink-label-dark',
        ].join(' ')}
      >
        {label}
      </span>
      <span
        className={[
          'text-[10px] font-medium tabular-nums',
          inverted ? 'text-white/60' : 'text-ink-subtitle dark:text-ink-subtitle-dark',
        ].join(' ')}
      >
        {String(event.hour ?? 9).padStart(2, '0')}h
      </span>
    </div>
  );
}
